export const returnDataRecord = (service) => {
    switch (true) {
        case ["47CO", "46CO"].includes(service):
            return {
                reasonConsultation: "",
                illnes: "",
                past: "",
                mental: "",
                areaAcademic: "",
                areaPersonal: "",
                areaWork: "",
                areaFamily: "",
                areaSocial: "",
                areaCouple: "",
                areaSexual: "",
                areaConsumeSPA: "",
                areaEconomic: "",
                areaRulesLimits: "",
                areaSuicidalIdeation: "",
                areaReligious: "",
                processExpectations: "",
                diagnosis: "",
                diagnosisRelated: [],
                followUpPlan: "",
                riskLevel: "",
                psychoEducation: "",
                referralSecondLevel: "",
                attentionRoutes: "",
                conclusions: "",
            }

        case ["571", "572"].includes(service):
            return {
                activities: "",
                anamnesis: "",
                familyInvolment: "",
                followUpPlan: "",
                objectiveSession: "",
                observations: "",
                progress: "",
                conclusions: "",
            }

        default:
            return {
                // Antecedentes
                pathologicalPatient: [],
                pathologicalPatientMedicine: "",
                pathologicalPatientExplanation: "",
                noPathologicalPatientAlcohol: "",
                noPathologicalPatientDrugs: "",
                noPathologicalPatientSmoking: "",
                noPathologicalPatientImmunization: "",
                noPathologicalPatientOthers: "",
                recordDadLive: "",
                recordDadSick: "",
                recordMomLive: "",
                recordMomSick: "",
                recordBroLive: "",
                recordBroHowMany: "",
                recordBroSick: "",
                recordGinecoMenarquia: "",
                recordGinecoRitmo: "",
                recordGinecoFUM: "",
                recordGinecoG: "",
                recordGinecoP: "",
                recordGinecoA: "",
                recordGinecoC: "",
                recordGinecoIVSA: "",
                recordGinecoAnti: "",
                recordGinecoAntiHow: "",
                // Atencion
                reasonConsultation: "",
                illnes: "",
                // physicalSignalTADerecho: "",
                // physicalSignalTAIzquierdo: "",
                // physicalFC: "",
                // physicalFrecuenceBreath: "",
                // physicalTemp: "",
                physicalWeight: "",
                physicalHeight: "",
                physicalIMC: "",
                relevantDetails: "",
                // physicalHeadNeck: "",
                // physicalChest: "",
                // physicalAbdomen: "",
                // physicalExtremity: "",
                mental: "",
                // neurologic: "",
                medicalOrders: "",
                medicalOrderDetail: "",
                // medicalProcedures: "",
                diagnosis: [],
                diagnosisRelated: [],
                // treatment: "",
            }
    }
}